#import "../../../shared/graphql/fragments/quote-money-fragment.graphql"

query GetInvoices($leadId: ID!) {
    invoices(leadId: $leadId) {
        id
        modalUrl
        displayStatus
        displayNumber
        total {
            ...QuoteMoneyFragment
        }
        slug
        shareableViewInBrowserLink
        sentTime
        createdTime
        publishedTime
        acceptedTime
        overdueDuration
    }
}
